import { render, staticRenderFns } from "./UOMListEdit.vue?vue&type=template&id=637cdb4f"
import script from "./UOMListEdit.vue?vue&type=script&lang=js"
export * from "./UOMListEdit.vue?vue&type=script&lang=js"
import style0 from "./UOMListEdit.vue?vue&type=style&index=0&id=637cdb4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports